
  
document.addEventListener("DOMContentLoaded", function(event) {
	siteWideFunctions();	
	getAllDropDowns();

});



function getAllDropDowns() {
	Array.from(document.querySelectorAll('div[data-dropdown]')).map(createDropDown)
}


function siteWideFunctions() {
	document.querySelector('.masthead').classList.add('in-transition');
	setTimeout(() => {
		document.querySelector('.masthead').classList.add('active');
	}, 1000);
}

function createDropDown(dropdown) {
  const padding = Number(dropdown.getAttribute('data-padding'));
  const button = dropdown.querySelector('button');
  const dropDownContent = dropdown.querySelector('div[data-content-wrapper]');

  button.addEventListener('click', () => toggleDropDown(button, dropDownContent, padding));
  if (dropdown.hasAttribute('data-open')) {
    toggleDropDown(button, dropDownContent, padding);
  }
}

function toggleDropDown(button,dropDownContent,padding = 60) {
	button.classList.toggle('open')
	const maxHeight = dropDownContent.scrollHeight
	if(dropDownContent.className.includes('open')){
		dropDownContent.classList.remove('open')
		dropDownContent.style.height = `0px`
	}else{
		dropDownContent.classList.add('open')
		dropDownContent.style.height = `${maxHeight + padding}px` 
	}

}





